export const TITLE = 'Lærernote';
export const PLACEHOLDER = 'Tilføj tekst...';
export const DELETE_TEXT = 'Slet tekst';